import { BaseDto } from '../base.dto';

export class GiftCardReasonDto extends BaseDto {
  name: string;
  merchantId: number;
  startDate: Date;
  endDate: Date;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
  isRevenueReason: number;
}
